import { render } from "./set.vue?vue&type=template&id=540f7ba4&scoped=true&ts=true"
import script from "./set.vue?vue&type=script&lang=ts"
export * from "./set.vue?vue&type=script&lang=ts"

import "./set.vue?vue&type=style&index=0&id=540f7ba4&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540f7ba4"]])

export default __exports__